module.exports = __webpack_public_path__ + "static/img/180153_4.790ab30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/180153_4.jpg
// module id = 1Bod
// module chunks = 1